import Vue from 'vue';

Vue.component('vuetable-royalty', () =>
    import(/* webpackChunkName: 'vuetable-royalty' */ './royalty-list.vue'),
);

Vue.component('vuetable-outlet-royalty', () =>
    import(/* webpackChunkName: 'vuetable-outlet-royalty' */ './outlet-list.vue'),
);

Vue.component('vuetable-tier-list', () =>
    import(/* webpackChunkName: 'vuetable-tier-list' */ './tier-list.vue'),
);

Vue.component('vuetable-station-list', () =>
    import(/* webpackChunkName: 'vuetable-station-list' */ './station-list.vue'),
);

Vue.component('vuetable-station-tier-list', () =>
    import(/* webpackChunkName: 'vuetable-station-list' */ './station-tier-list.vue'),
);

Vue.component('royalty-v2-index', () =>
    import(/* webpackChunkName: 'royalty-v2-index' */ './royalty-v2/royalty-v2-index.vue'),
);
